import React, { useState, useEffect, Fragment } from "react";
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack, Alert, Collapse } from '@mui/material';
//import Profile from "./Profile";
import { useAuth0 } from "@auth0/auth0-react";
import CustomToolbar from "./Widgets/CustomToolbar";
import VendorRequestDialog from "./VendorRequest";
import SuccessError from "./Widgets/SuccessError";
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import VendorRequestHistoryCard from "./Widgets/VendorRequestHistoryCard";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import useSWR from 'swr';


var reRender = 1;

const useAsyncLoad = (url) => {

  const [errorA, setErrorA] = useState(null);
  const [loading, setLoading] = useState(true);
  const [vendors, setVendors] = useState(null);


  const x = reRender;
  const { getAccessTokenSilently } = useAuth0();
  async function GetVendorData(url) {

    const audience = 'https://piaapplication.azurewebsites.net/';

    const accessToken = localStorage.getItem("userToken");
    
    // = await getAccessTokenSilently({
    //   audience: audience,
    //   //scope: "read:messages",
    // });

    //setAccessToken(accessToken);
    //console.log(accessToken);

    //var url = "vendors/getvendors";

    ///var bearer = 'Bearer ' + accessToken;

    var vendorData = await fetch(url, {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': accessToken,
        'Content-Type': 'application/json'
      }
    });

    var data = await vendorData.json();

    data.accessToken = accessToken;
    //console.log(data);
    return data;

  };


  async function loadData(url) {

    try {

      setErrorA(null);
      if (x < 2) {
        setLoading(true);
      }

      var data = await GetVendorData(url);

      setVendors(data);
      //console.log(data);

    } catch (e) {
      setLoading(false);
      setErrorA(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData(url);
    // eslint-disable-next-line
  }, [x]);

  return [vendors, errorA, loading];
}


const FetchVendors = () => {
  const [value, error, loading] = useAsyncLoad("vendors/getvendors");
  return [value, error, loading];
}

async function FetchRequests(id, accessToken) {

  // var bearer = 'Bearer ' + accessToken;
  //var token = accessToken;
  //console.log(accessToken);
  var result = await fetch("vendors/getrequests?id=" + id,
    {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': accessToken,
        'Content-Type': 'application/json'
      }
    }
  ).then(data => data.json()).then(
    (data) => {
      return (data);
    },
    (error) => {
      // setLoading(false);
      //setError(error);
    }
  );
  return result;
}

export default function DataTable() {

  const [open, setOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [deleteName, setDeleteName] = React.useState('');
  const [deleteId, setDeleteId] = React.useState('');
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const [requestSuccessOpen, setRequestSuccessOpen] = React.useState(false);
  const [requestErrorOpen, setRequestErrorOpen] = React.useState(false);
  const [requestSuccessMessage, setRequestSuccessMessage] = React.useState(false);
  const [requestErrorMessage, setRequestErrorMessage] = React.useState(false);
  const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
  const [vendorRequestOpen, setVendorRequestOpen] = React.useState(false);
  const [vendorRequestReminderOpen, setVendorRequestReminderOpen] = React.useState(false);
  const [vendorId, setVendorId] = useState();
  const [initialRequestBody, setInitialRequestBody] = useState();
  const [accessToken, setAccessToken] = useState();
  const [currentVendorRequests, setCurrentVendorRequests] = useState([]);
  const [generalOpen, setGeneralOpen] = useState(true);
  const [requestHistoryOpen, setRequestHistoryOpen] = useState(false);
  const [tenantId, setTenantId] = useState(0);
  const [masterPiaExists, setmasterPiaExists] = useState(false);
  const [reqestReminder, setreqestReminder] = useState(false);


  const UrlRe = RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');

  const validationSchema = Yup.object().shape({
    id: Yup.number(),
    name: Yup.string()
      .required('Vendor Name is required')
      .max(150, 'Vendor must not exceed 150 characters'),
    phone: Yup.string()
      .max(15, 'Phone must not exceed 15 characters'),
    url: Yup.string()
      .required('URL is required')
      .matches(UrlRe, 'URL is not valid')
      .max(500, 'URL must not exceed 350 characters'),
    privacyOfficer: Yup.string()
      .required('Privacy Office info is required')
      .max(500, 'Privacy Office info must not exceed 350 characters'),
    privacyPolicyUrl: Yup.string()
      .matches(UrlRe, 'URL is not valid')
      .max(500, 'URL must not exceed 350 characters')
      .nullable(),

  });

  const onSubmit = data => {
    if (data.id === -1) {
      saveVendor(data, 'Add', accessToken);
    } else {
      saveVendor(data, 'Save', accessToken);
    }
    setOpen(false);
  };
  const onApprove = data => {
   
      saveVendor(data, 'Approve', accessToken);
    
    setOpen(false);
  };
  const showSuccess = message => {
    setSuccessOpen(true);
    setSuccessMessage(message);
    setTimeout(() => setSuccessOpen(false), 3000);
  };

  const showError = message => {
    setErrorOpen(true);
    setErrorMessage(message);
    setTimeout(() => setErrorOpen(false), 3000);
  };

  const showRequestSuccess = message => {
    setRequestSuccessOpen(true);
    setRequestSuccessMessage(message);
    setTimeout(() => setRequestSuccessOpen(false), 3000);
  };

  const showRequestError = (message) => {
    setRequestErrorOpen(true);
    setRequestErrorMessage(message);
    setTimeout(() => setRequestErrorOpen(false), 3000);
  };


  async function saveVendor(vendor, saveOrAddOrDelete, accessToken) {

    // const { getAccessTokenSilently } = useAuth0();
    // const audience = 'https://piaapplication.azurewebsites.net/';

    // const accessToken = await getAccessTokenSilently({
    //   audience: audience,
    //   //scope: "read:messages",
    // });

    var method = '';
    var url = ''
    if (saveOrAddOrDelete === 'Add') {
      method = 'POST';
      url = 'vendors/';
    } else if (saveOrAddOrDelete === 'Save') {
      method = 'PUT';
      url = 'vendors/' + vendor.id;
    }
    else if (saveOrAddOrDelete === 'Approve') {
      method = 'PUT';
      url = 'vendors/approve/' + vendor.id;
    }
    else if (saveOrAddOrDelete === 'Delete') {
      method = 'DELETE';
      url = 'vendors/' + vendor.id;
    }

    debugger;
    try {
      const requestOptions = {
        method: method,
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(vendor)
      };

      var result = await fetch(url, requestOptions);

    
      if (result.status === 500) {
        showError();
      } else if (result.status === 404) {
        showError("Error saving vendor");
      }
      
      else {
        switch (saveOrAddOrDelete) {
          case 'Save':
            showSuccess("Update Successful");
            break;
          case 'Add':
            showSuccess("New record added successfully");
            break;
          case 'Delete':
            showSuccess("Record Deleted");
            break;
          default:
            showSuccess("Update Successful");
        }
      }
    } catch (e) {

      showError();
    } finally {
      reRender = reRender + 1;
      //console.log(reRender);
    }
  }

  const {
    register,
    //control,
    setValue,
    handleSubmit,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const columns = [
    {
      field: "Actions", width: 150, sortable: false,
      disableExport: 'true',
      renderCell: (cellValues) => {
        return (

          <div>
            {/* {vendorData.userAndTenant.isSuperAdmin && */}
            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleClickOpen(event, cellValues, vendorData.accessToken);
              }}
            >
              <EditIcon />
            </Button>
            {/* } */}
           {vendorData.userAndTenant.isSuperAdmin &&
              <Button
                variant="outlined"
                color="primary"
                onClick={(event) => {
                  handleDeleteOpen(event, cellValues);
                }}
              >
                <DeleteIcon />
              </Button>
            }
          </div>
        );
      }
    },
    {
      field: 'name', headerName: 'Vendor Name', minWidth: 130, flex: 1
      , renderCell: (cellValues) => {
        if (cellValues.row.tenantId === 0) {
          return (<div>{cellValues.row.name}</div>)
        }
        else if(vendorData.userAndTenant.isSuperAdmin) {
          return (<div><Typography color="red">{cellValues.row.name}  
          (Tenant - {cellValues.row.tenantName})</Typography></div>)
        }
        else {
          return (<div><Typography color="red">{cellValues.row.name}&nbsp;
          (Pending)</Typography></div>)
        }
      }
    },
    // { field: 'phone', headerName: 'Phone', width: 130 },
    {
      field: 'url', headerName: 'URL', minWidth: 190, flex: 1,
      renderCell: (cellValues) => {
        var fullUrl;
        if (cellValues.row.url.startsWith('www')) {
          fullUrl = 'http://' + cellValues.row.url;
        } else {
          fullUrl = cellValues.row.url;
        }
        return (<a target="_blank" rel="noreferrer" href={fullUrl}>{cellValues.row.url}</a>)
      }
    },

    { field: 'privacyOfficer', headerName: 'Privacy Office', minWidth: 100, flex: 1 },
    {
      field: 'privacyPolicyUrl', headerName: 'Privacy URL', minWidth: 200, flex: 1, hide: true,
      renderCell: (cellValues) => {
        if (!cellValues.row.privacyPolicyUrl) {
          return '';
        }
        var fullUrl;
        if (cellValues.row.privacyPolicyUrl.startsWith('www')) {
          fullUrl = 'http://' + cellValues.row.privacyPolicyUrl;
        } else {
          fullUrl = cellValues.row.privacyPolicyUrl;
        }
        return (<a target="_blank" rel="noreferrer" href={fullUrl}>{cellValues.row.privacyPolicyUrl}</a>)
      }
    },

  ];


  var returnData = FetchVendors();
  var vendorData = returnData[0];
  //console.log(vendorData);

  if (vendorData && !accessToken) {

    setAccessToken(localStorage.getItem("userToken"));
   
  }

  var loading = returnData[2];
  var error = returnData[1];

  const handleClickOpen = (event, cellValues, accessToken) => {
    var dataRow = cellValues.row;
    setValue("id", dataRow.id);
    setVendorId(dataRow.id);
    setInitialRequestBody(dataRow.requestEmailBody);
    //setAccessToken(vendorData.accessToken);
    setValue("accessToken", accessToken);
    setValue("name", dataRow.name);
    setValue("phone", dataRow.phone);
    setValue("url", dataRow.url);
    setValue("privacyOfficer", dataRow.privacyOfficer);
    setValue("privacyPolicy", dataRow.privacyPolicy);
    setValue("privacyNotification", dataRow.privacyNotification);
    setValue("privacyPolicyUrl", dataRow.privacyPolicyUrl);
    
    setmasterPiaExists(dataRow.masterPiaExists);
    setEditOrAddTitle('Edit');
    setTenantId(dataRow.tenantId);
    clearErrors();
    setOpen(true);
    FetchRequests(dataRow.id, accessToken).then((requestData) => {

      setCurrentVendorRequests(requestData);
    });


  };



  const addVendor = (event, cellValues) => {
    setValue("id", -1);
    setValue("name", '');
    setValue("phone", '');
    setValue("url", '');
    setValue("privacyOfficer", '');
    setValue("privacyPolicy", '');
    setValue("privacyNotification", '');
    setValue("privacyPolicyUrl", '');
    setEditOrAddTitle('Add');
    clearErrors();
    setOpen(true);

  };

  const addVendorRequest = (vendorId) => {
    //check if Master PIA exists for this vendor

    //get text for email request body

   
    //setValue("id", cellValues.row.id);
    
    setValue("vendorId", vendorId);
    setVendorId(vendorId);
    if (!vendorRequestOpen) {
      setreqestReminder(false);
      setVendorRequestOpen(true);
    }

  };
  // const addVendorReminderRequest = (event, cellValues) => {
  //   //check if Master PIA exists for this vendor


  //   if (!vendorRequestReminderOpen) {
  //     setreqestReminder(true);
  //     setVendorRequestReminderOpen(true);
  //   }

  // };


  
  const handleRequestCancel = () => {
    setVendorRequestOpen(false);
  };

  const handleDeleteOpen = (event, cellValues) => {
    var dataRow = cellValues.row;
    setDeleteName(dataRow.name);
    setDeleteId(dataRow.id)
    setDeleteOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteOpen(false);
  };

  const handleDelete = () => {
    var data = { id: deleteId };
    // data.id = deleteId;
    saveVendor(data, 'Delete');
    reRender = reRender + 1;
    setDeleteOpen(false);
  };
  const closeSuccess = () => {
    setSuccessOpen(false);
  };
  const closeError = () => {
    setErrorOpen(false);
  };
  const closeRequestSuccess = () => {
    setRequestSuccessOpen(false);
  };
  const closeRequestError = () => {
    setRequestErrorOpen(false);
  };
  const titleBoxBackgroundColour = '#1976d21a';
  if (loading) {
    return (
      // <div>
      //   Loading...
      // </div>

      <DarkBackground >
        <LoadingOverlay
          active={true}

          spinner={true}
          text="Loading..."
        >
        </LoadingOverlay>
      </DarkBackground>

    )
  } else if (loading === false && error !== null) {
    return (
      <Stack spacing={2}>
        <Alert severity="error">Error occured loading vendors</Alert>
      </Stack>

    )
  }

  return (
    <div>
      <SuccessError
        successMessage={successMessage}
        errorMessage={errorMessage}
        closeError={() => closeError()}
        closeSuccess={() => closeSuccess()}
        successOpen={successOpen}
        errorOpen={errorOpen}
      >
      </SuccessError>

      <Box
        component="span"
        m={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h3" component="h2">
          Vendors
        </Typography>

        <Button variant="outlined" onClick={addVendor}>Add Vendor</Button>
      </Box>

      <div>

        <div style={{ height: '70vh', width: '100%' }}>
          <DataGrid
            //componentsProps={{ toolbar: { csvOptions: { allColumns: true } } }} 
            fullWidth

            components={{
              Toolbar: CustomToolbar,
            }}
            initialState={{
              pagination: {
                pageSize: 1000,
              },
            }}
            height='100%'
            rows={vendorData.vendors}
            columns={columns}
            //pageSize={100}
            rowsPerPageOptions={[50, 100]}
          //checkboxSelection
          />

        </div>
        <Dialog open={open} onClose={handleCancel} maxWidth="md">
          <DialogTitle>

            <Box
              component="span"
              m={1}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              // border={3}
              sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}
            >
              {editOrAddTitle} Vendor
              {(editOrAddTitle === 'Edit') &&
                <Button variant="outlined" onClick={() => addVendorRequest(vendorId)}>Initiate PIA Request</Button>}
            </Box>

          </DialogTitle>
          <form>
            <DialogContent>

              <DialogContentText>
                <SuccessError
                  successMessage={requestSuccessMessage}
                  errorMessage={requestErrorMessage}
                  closeError={() => closeRequestError()}
                  closeSuccess={() => closeRequestSuccess()}
                  successOpen={requestSuccessOpen}
                  errorOpen={requestErrorOpen}
                >
                </SuccessError>

              </DialogContentText>

              <Fragment>
                <Paper variant="outlined" >
                  <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                    onClick={() => setGeneralOpen(!generalOpen)}
                  >
                    <Grid container sx={{ justifyContent: "space-between" }} >
                      <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                        Vendor Information
                      </Typography>
                      <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                        {generalOpen ? <RemoveIcon /> : <AddIcon />}
                      </Typography>

                    </Grid>
                  </Box>


                  <Collapse in={generalOpen} width={'100%'}>
                    <Box sx={{ border: 1 }} px={1} py={2}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            required
                            id="id"
                            name="id"
                            label="ID"
                            fullWidth
                            hidden
                            margin="dense"
                            {...register('id')}

                          />

                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            required
                            id="name"
                            name="name"
                            label="Vendor Name"
                            fullWidth
                            margin="dense"
                            {...register('name')}
                            error={errors.name ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.name?.message}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                          <TextField
                            required
                            id="url"
                            name="url"
                            label="Vendor URL"
                            fullWidth
                            margin="dense"
                            {...register('url')}
                            error={errors.url ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.url?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            required
                            id="privacyOfficer"
                            name="privacyOfficer"
                            label="Privacy Office Contact Information"
                            multiline
                            maxRows={3}
                            fullWidth

                            margin="dense"
                            {...register('privacyOfficer')}
                            error={errors.privacyOfficer ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.privacyOfficer?.message}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Link to Privacy Policy"
                            id="privacyPolicyUrl"
                            name="privacyPolicyUrl"
                            label="Link to Privacy Policy"
                            multiline
                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('privacyPolicyUrl')}
                            error={errors.privacyPolicyUrl ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.privacyPolicyUrl?.message}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Collapse>

                  {currentVendorRequests.length > 0 && (
                    <Fragment>
                      <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                        onClick={() => setRequestHistoryOpen(!requestHistoryOpen)}
                      >
                        <Grid container sx={{ justifyContent: "space-between" }} >
                          <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                            PIA Request History
                          </Typography>
                          <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                            {requestHistoryOpen ? <RemoveIcon /> : <AddIcon />}
                          </Typography>

                        </Grid>
                      </Box>

                      <Collapse in={requestHistoryOpen} width={'100%'}>
                        <Box sx={{ border: 1 }} px={1} py={2}>

                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}  >

                              <VendorRequestHistoryCard
                                rows={currentVendorRequests}
                              >
                              </VendorRequestHistoryCard>
                            </Grid>
                          </Grid>

                        </Box>
                      </Collapse>

                    </Fragment>
                  )}

                </Paper>
              </Fragment>
            </DialogContent>

            <DialogActions>
            {vendorData.userAndTenant.isSuperAdmin && tenantId > 0 && (
                <Button color="primary" onClick={handleSubmit(onApprove)}>Approve</Button>
              )}
              {vendorData.userAndTenant.isSuperAdmin && (
                <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
              )}
              {!vendorData.userAndTenant.isSuperAdmin && (
                <Button color="primary" onClick={handleSubmit(onSubmit)}>Submit Vendor to ProcessPro</Button>
              )}
              <Button onClick={handleCancel}>Cancel</Button>

            </DialogActions>
          </form>

        </Dialog>

        <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Delete Vendor</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to Delete <strong>{deleteName} ?</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDelete}>Delete</Button>
            <Button onClick={handleDeleteCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>
        <VendorRequestDialog
          vendorId={vendorId}
          vendorRequestOpen={vendorRequestOpen}
          setVendorRequestOpen={setVendorRequestOpen}
          onClose={handleRequestCancel}
          accessToken={vendorData.accessToken}
          showSuccess={showRequestSuccess}
          showError={showRequestError}
          masterPiaExists={masterPiaExists}
          initialRequestBody={initialRequestBody}
        // vendorId = {vendorId}
        ></VendorRequestDialog>

      </div>

    </div>


  );

}